import React, {Component} from "react"
import Success from "@irati/ui/src/Success"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Div from "./styled/Div"

interface Props extends InjectIntl {
  show: boolean
  onHide: () => void
}

interface State {
  saved: boolean
}

class SuccessStep extends Component<Props, State> {
  static defaultProps = {}

  constructor(props: Props) {
    super(props)
    this.state = {
      saved: false
    }
  }

  UNSAFE_componentWillReceiveProps(newProps: Props) {
    const {onHide} = this.props

    if (newProps.show) {
      setTimeout(() => {
        onHide()
      }, 2000)
    }
  }

  render() {
    const {show, formatMessage} = this.props

    if (!show) {
      return null
    }

    return (
      <Div>
        <Success message={formatMessage({id: "admin.components.successStep.success.message"})} />
      </Div>
    )
  }
}

export default injectIntl(SuccessStep)
